import React from "react";

const Sparkles = ({
  selectedSparkle,
  setSelectedSparkle,
  sparkleText,
  setSparkleText,
  alignText,
  setAlignText,
}) => {
  const sparkleOptions = [
    { id: "plain", label: "Plain" },
    { id: "silver", label: "Silver" },
    { id: "gold", label: "Gold" },
  ];

  const textAlign = [
    { id: "outside_left", label: "Outside left" },
    { id: "center_streamer", label: "Center streamer" },
    { id: "outside_right", label: "Outside right" },
  ];

  const handleAlignTextChange = (label) => {
    setAlignText(label);
  };

  return (
    <div className="p-6 max-w-4xl m-4 border border-gray-200 bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
      <h2 className="text-xl font-semibold text-gray-800 mb-6 bg-white/60 p-3 rounded-lg shadow-sm backdrop-blur-sm border border-gray-100">
        SPARKLES
      </h2>

      <div className="relative space-y-8 p-4 bg-white/40 rounded-lg backdrop-blur-sm">
        <div>
          <h3 className="text-lg font-medium text-purple-800 mb-5 flex items-center">
            <span className="mr-2">✨</span>
            Select Sparkles
          </h3>

          <div className="space-y-4 pl-2">
            {sparkleOptions.map((option) => (
              <label
                key={option.id}
                className="flex items-center space-x-4 cursor-pointer group hover:transform hover:translate-x-1 transition-transform duration-200"
              >
                <div className="relative">
                  <input
                    type="radio"
                    name="sparkles"
                    value={option.id}
                    checked={selectedSparkle === option.label}
                    onChange={(e) => setSelectedSparkle(option.label)}
                    className="w-5 h-5 border-2 text-md border-gray-300 rounded-full appearance-none cursor-pointer checked:border-purple-800 checked:border-6 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-800/50"
                  />
                </div>
                <span className="text-lg text-gray-700 group-hover:text-cyan-600 transition-colors font-medium">
                  {option.label}
                </span>
              </label>
            ))}
          </div>
        </div>

        <p className="text-sm text-gray-600 italic bg-white/50 p-2 rounded-md inline-block">
          (Adding sparkles to your order will impact the pricing)
        </p>
        <div className="space-y-4">
          <h3 className="text-lg font-medium text-purple-800 flex items-center">
            <span className="mr-2">📏</span>
            Text Position
          </h3>
          <div className="grid grid-cols-2 gap-4 pl-2">
            {textAlign.map((align) => (
              <label
                key={align.id}
                className="flex items-center space-x-3 cursor-pointer group hover:transform hover:translate-y-[-2px] transition-transform duration-200 bg-white/80 p-3 rounded-lg shadow-md hover:shadow-lg"
              >
                <div className="relative">
                  <input
                    type="checkbox"
                    name="alignment"
                    value={align.label}
                    checked={alignText?.includes(align?.label)}
                    onChange={() => handleAlignTextChange(align.label)}
                    className="hidden peer"
                  />
                  <div className="w-5 h-5 border-2 border-gray-300 rounded-md peer-checked:bg-purple-800 peer-checked:border-purple-800 peer-checked:shadow-lg transition-all duration-200 flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-3 h-3 text-white opacity-0 peer-checked:opacity-100 transition-opacity duration-150"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                </div>
                <span className="text-sm text-gray-700 group-hover:text-cyan-600 transition-colors">
                  {align.label}
                </span>
              </label>
            ))}
          </div>
        </div>
        <div className="space-y-3">
          <label className="text-lg font-medium text-purple-800 flex items-center">
            <span className="mr-2">✍️</span>
            Enter the Text
          </label>
          <textarea
            value={sparkleText}
            onChange={(e) => setSparkleText(e.target.value)}
            maxLength={45}
            className="w-full min-h-[120px] p-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500/50 focus:border-transparent resize-none transition-all duration-200 bg-white/80 hover:bg-white"
            placeholder="Enter your text here..."
          />
        </div>
      </div>
    </div>
  );
};

export default Sparkles;
